import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { SortingDirection } from '../../../../../../../models/sortingDirection.model';
import { IImageFilters, SortingBy } from '../../../imageFilters.model';
import { FiltersDropdownRow } from '../FiltersDropdownRow';

interface ISortingFilterInfoProps {
  imageFilters: IImageFilters;
}

export const SortingFilterInfo = observer((props: ISortingFilterInfoProps): ReactElement => {
  const { t } = useTranslator();

  const selected = props.imageFilters.sorting
    .slice()
    .sort((a, b) => a.order - b.order)
    .map((x) => ({
      value: x.by || SortingBy.Name,
      label: `${t(`sorting_by.${x.by || SortingBy.Name}`)} ${t(x.direction === SortingDirection.ASC ? 'image_filters.order_type_asc' : 'image_filters.order_type_desc')}`,
    }));

  return (
    <FiltersDropdownRow
      label={t('image_filters.used_sorting')}
      count={selected.length}
    >
      <>
        {selected.map((d, i) => (
          <div key={i}>{d.label}</div>
        ))}
      </>
    </FiltersDropdownRow>
  );
});
